<template>
  <div class="contai_h">
    <!-- 这是头部信息 -->
    <div class="contai">
      <i class="el-icon-s-home">
        <router-link to="/">首页</router-link>
        <span class="head_text">>修改今日金价 </span>
      </i>
      <div class="haed_cont">
        <span>今天是：{{ deta }}</span>
      </div>
    </div>

    <!-- 这是操作功能区 -->
    <div class="cont_co">
      <div class="cont_coo">
        <el-table :data="this.items" border style="width: 66%">
          <el-table-column prop="input" label="千足金典当价格：" width="200">
          </el-table-column>
          <el-table-column prop="zinput" label="足金典当价格：" width="200">
          </el-table-column>
          <el-table-column prop="kinput" label="18k金典当价格：" width="200">
          </el-table-column>
          <el-table-column prop="address" label="待添加" width="200">
          </el-table-column>
          <el-table-column prop="scdate" label="上次修改时间：" width="250">
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template>
              <el-button @click="handleClick()" type="text" size="small"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 修改操作栏 -->
        <div class="cont_xg" v-if="conx">
          <el-input
            v-model="inputs"
            placeholder="千足金典当价格"
            class="cont_x"
          ></el-input>
          <el-input
            v-model="input"
            placeholder="足金典当价格"
            class="cont_x"
          ></el-input>
          <el-input
            v-model="inpu"
            placeholder="18k典当价格"
            class="cont_x"
          ></el-input>

          <!-- 提交按钮 -->
          <div class="contj">
            <el-button type="success" plain @click="con_tj">确定修改</el-button>
          </div>
        </div>
        <!-- 断当价格 -->
        <div class="cont_dua">
          <el-table :data="this.items" border style="width: 66%">
            <el-table-column prop="inputs" label="千足金断当价格：" width="200">
            </el-table-column>
            <el-table-column prop="zinputs" label="足金断当价格：" width="200">
            </el-table-column>
            <el-table-column prop="kinputs" label="18k金断当价格：" width="200">
            </el-table-column>
            <el-table-column prop="address" label="待添加" width="200">
            </el-table-column>
            <el-table-column prop="sddate" label="上次修改时间：" width="250">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template>
                <el-button @click="duanClick()" type="text" size="small"
                  >修改</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <!-- 断当价格修改 -->
          <div v-if="conds">
            <el-input
              v-model="ins"
              placeholder="千足金断当价格"
              class="cont_x"
            ></el-input>
            <el-input
              v-model="inps"
              placeholder="足金断当价格"
              class="cont_x"
            ></el-input>
            <el-input
              v-model="inpus"
              placeholder="18k断当价格"
              class="cont_x"
            ></el-input>

            <!-- 提交按钮 -->
            <div class="contj">
              <el-button type="success" plain @click="con_dx"
                >确定修改</el-button
              >
            </div>
          </div>
        </div>
        <!-- 断当结束 -->
        <div class="text_h">
          <h3>
            **注意**  在提交修改时，请确定每一个输入框都有值，否则该项会默认为空！！！
          </h3>
        </div>
      </div>
    </div>
    <!-- 往期查询 -->
    <div class="cont_two">
      <div class="cont_tabs">
        <el-tabs v-model="activeName" @tab-click="handlClick">
          <el-tab-pane label="往期典当价格" name="first">
            <el-table :data="pawn" style="width: 100%" >
              <el-table-column prop="scdate" label="修改日期" width="300">
              </el-table-column>
              <el-table-column prop="input" label="千足金典当格价" width="300">
              </el-table-column>
              <el-table-column prop="zinput" label="足金典当价格" width="300">
              </el-table-column>
              <el-table-column prop="kinput" label="18k金典当价格" width="300">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="往期断当价格" name="second">
            <el-table :data="brek" style="width: 100%" >
              <el-table-column  prop="scdate" label="修改日期" width="300">
              </el-table-column>
              <el-table-column prop="inputs" label="千足金断当格价" width="300">
              </el-table-column>
              <el-table-column prop="zinputs" label="足金断当价格" width="300">
              </el-table-column>
              <el-table-column prop="kinputs" label="18k金断当价格" width="300">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "modify",
  data() {
    return {
      deta: "", //今天时间
      len: "", //长度
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      items: [], //数据存储
      conx: false, //是否显示数据操作
      conds: false, //s是否显示断当操作栏
      inputs: "", //千足金修改的价格
      input: "", //足金待修改的价格
      inpu: "", //18k修改的价格
      ins: "", //千足金修改断当价格
      inps: "", //足金断当修改价格
      inpus: "", //18k断当修改价格
      activeName: "first",
      pawn: [], //往期典当的数据
      brek:[], //往期断当的数据
    };
  },
  methods: {
    // 典当操作栏开关
    handleClick() {
      this.conx = !this.conx;
    },
    // 断当操作栏开关
    duanClick() {
      this.conds = !this.conds;
    },
    con_dx() {
      this.$confirm("确定要修改断当的金价?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //修改断当金价
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("date_xg").doc("9170e7955f617675000d29001647d34f").update({data:{inputs: "' +
                this.ins +
                '",kinputs:"' +
                this.inpus +
                '",zinputs:"' +
                this.inps +
                '",sddate:"' +
                dayjs().format("YYYY-MM-DD HH:mm") +
                '"}})',
            })
            .then(() => {
              this.$message({
                message: "断当金价修改成功",
                type: "success",
              });
            });

          //把断当金价添加到数据库方便查询
          this.axios.post(
            "/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN,
            {
              env: `${this.userData.env}`,
              query:
                'db.collection("date_xg").add({data: [{inputs:"' +
                this.ins +
                '",kinputs:"' +
                this.inpus +
                '",zinputs:"' +
                this.inps +
                '",scdate:"' +
                dayjs().format("YYYY-MM-DD HH:mm") +
                '",type:"brek"}]})',
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    con_tj() {
      this.$confirm("确定要修改典当的金价?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //修改今日金价
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("date_xg").doc("9170e7955f617675000d29001647d34f").update({data:{input: "' +
                this.inputs +
                '",kinput:"' +
                this.inpu +
                '",zinput:"' +
                this.input +
                '",scdate:"' +
                dayjs().format("YYYY-MM-DD HH:mm") +
                '"}})',
            })
            .then(() => {
              this.$message({
                message: "金价修改成功",
                type: "success",
              });
            });

          //把典当金价添加到数据库方便查询
          this.axios.post(
            "/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN,
            {
              env: `${this.userData.env}`,
              query:
                'db.collection("date_xg").add({data: [{input:"' +
                this.inputs +
                '",kinput:"' +
                this.inpu +
                '",zinput:"' +
                this.input +
                '",scdate:"' +
                dayjs().format("YYYY-MM-DD HH:mm") +
                '",type:"pawn"}]})',
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    // tabs切换点击函数
    handlClick(tab) {
      if (tab.name == "first") {
        //请求数据库里的往期典当价格
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: 'db.collection("date_xg").where({type:"pawn"}).get()',
          })
          .then((ab) => {
            ab.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.pawn = ab.data.data;
          });
      }else if(tab.name=="second"){
         //请求数据库里的往期断当价格
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: 'db.collection("date_xg").where({type:"brek"}).get()',
          })
          .then((ac) => {
            ac.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.brek = ac.data.data;
          });
      }
    },
  },
  created(){
    //获取到this.ACCESS_TOKEN
     this.getTokens()

      //获取当前登录的用户数据
    this.getUserToken()
  },

  mounted() {
    this.deta = dayjs().format("YYYY-MM-DD ddd");
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");
  setTimeout(()=>{
     //请求金价数据
    this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query:
          'db.collection("date_xg").doc("9170e7955f617675000d29001647d34f").get()',
      })
      .then((aa) => {
        if(aa.data.errcode !==0){
          return  this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
        }
        aa.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
        this.items = aa.data.data;
      });

    //请求数据库里的往期价格
    this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: 'db.collection("date_xg").where({type:"pawn"}).get()',
      })
      .then((ab) => {
        ab.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
        this.pawn = ab.data.data;
      });
  },800)
   
  },
};
</script>
<style scoped>
.contai {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
}
.contai i {
  font-size: 25px;
  margin: 13px 40px;
}
.head_text {
  font-size: 20px;
  margin: 2px 6px;
}
.router-link-active {
  text-decoration: none;
  font-size: 20px;
  margin-left: 10px;
}
.haed_cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
}
.haed_cont {
  font-size: 20px;
}
.cont_co {
  margin: 10px 0px;
  width: 100%;
  /* height: 300px; */
  background-color: #ffffff;
}

.cont_coo {
  margin: 0 30px;
}
.cont_x {
  width: 200px;
}
.contj {
  margin: 20px 0;
}
.cont_two {
  width: 100%;
  background-color: #ffffff;
  margin: 15px 0px;
}
.cont_dua {
  margin: 20px 0;
}
.cont_tabs {
  margin: 10px 30px;
}
.text_h{
  padding: 5px 0;
  color: red;
}
</style>